import { InvoiceReport } from './InvoiceReport';

export default InvoiceReport;
